import __request__ from "routing/request";
export function allFieldTypes() {
  return __request__("GET", "/views/fields", null, {}, {
    "Accept": ["application/json"]
  });
}
export function byStreams(JSONbody) {
  return __request__("POST", "/views/fields", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function triggerFieldTypePolling() {
  return __request__("POST", "/views/fields/poll", null, {}, {
    "Accept": ["application/json"]
  });
}
